import { getChantiers } from "../apis";
import { Chantier } from "../interfaces";

import colorPalette from "./colorPalette";

export async function getColorPlanning() : Promise<Chantier[]>{
    
    const listChantier = await getChantiers();
    
    listChantier.map((chantier, i) => {        
        chantier.color = colorPalette[i]
    })
    return listChantier;
}